export const API_NAME = "LetsAdCofinoProd";
export const API_NAMELA = "LetsAdCofinoProd";
export const LAMBDA_FUNCTION_ = "L";
